import React from 'react'
import { Dropdown, MenuItem } from 'react-bootstrap'
import i18next from 'i18next'

import { availableLanguages } from '../assets/translations/availableLanguages'
import analysisPagesIcon from './../assets/images/analysis-pages.png'

export default class ExpertsAtWorkDownload extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      language: 'en'
    }
  }

  render() {
    const languages = availableLanguages.filter(l => ['en'].includes(l.key))

    return (
      <Dropdown id="analysis-page" pullRight>
        <Dropdown.Toggle bsStyle="link" noCaret>
          <img src={analysisPagesIcon} />

          <span>{'Experts in work-guide'}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {languages.map((l, key) => (
            <MenuItem
              eventKey={key}
              key={key}
              onClick={() =>
                (window.location.href = `/api/support/download/${l.key}/wopi-experts-in-work-guide.pdf`)
              }
            >
              {i18next.t(l.translationKey)}
            </MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ExpertsAtWorkDownload.js